<div class="flex flex-col gap-4">
  <section class="flex flex-col gap-2 text-center">
    <h1 class="pb-4">Herzlich willkommen bei TauRes!</h1>
    <p class="bodytext-regular-multiline">
      Mit deinem Entschluss, uns näher kennenzulernen, ist der erste Schritt zu einer Teilnahme an unserem Assessment-Center (AC1) getan. Deine
      Eintrittskarte zu dem AC1 verbirgt sich hinter dem Menüpunkt "Deine Bewerbung“.
    </p>
    <p class="bodytext-regular-multiline">
      Mit dem Bewerbungsformular hast du die Möglichkeit, uns mehr Informationen über deine Ausbildung, deine bisherigen beruflichen Erfahrungen,
      deine privaten Interessen und natürlich über deine Motivation für eine Vertriebspartnerschaft mitzuteilen. Je besser wir uns kennenlernen, desto
      klarer und einfacher ist die Entscheidung für eine langfristige Zusammenarbeit.
    </p>
    <p class="bodytext-regular-multiline">
      Deshalb laden wir dich herzlich dazu ein, uns schon vorab so viele Fragen wie nur möglich zu stellen. Wir freuen uns sehr, dich näher und
      persönlich kennenzulernen!
    </p>
  </section>

  <p-card>
    <div class="flex flex-col md:flex-row gap-4 items-center p-3">
      <img src="../../../../assets/bewerbung.jpg" alt="Begrüßungsbild" class="w-full md:w-1/2 stock-image" />
      <div class="w-full md:w-1/2 flex flex-col gap-2 items-center">
        <h4>Deine Bewerbung</h4>
        <p-button
          severity="help"
          label="Mehr erfahren"
          icon="pi-chevron-right"
          rounded="true"
          [routerLink]="['/vp', this.stateService.getToken(), 'cv']"
        ></p-button>
      </div>
    </div>
  </p-card>

  <section class="flex flex-col gap-4">
    <h1 class="text-center">Deine Ansprechpartner</h1>
    <div class="flex flex-col md:flex-row gap-4">
      @if (this.stateService.getVpManager()) {
        <app-contact-card
          [contactData]="this.stateService.getVpManager()!"
          [imageUrl]="vpManagerUrl"
          jobTitle="Manager und Gesellschafter der TauRes GmbH"
          class="w-full md:w-1/2"
        ></app-contact-card>
      } @else {
        <p-skeleton height="100%" class="w-full h-90"></p-skeleton>
      }

      @if (this.stateService.getAweManager()) {
        <app-contact-card
          [contactData]="this.stateService.getAweManager()!"
          [imageUrl]="aweManagerUrl"
          jobTitle="Leiter Vertriebspartnerprozess"
          class="w-full md:w-1/2"
        ></app-contact-card>
      } @else {
        <p-skeleton height="100%" class="w-full h-90"></p-skeleton>
      }
    </div>
  </section>
</div>
